var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburger = function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8c.6 0 1-.5.8-1-.5-1.6-2.5-3-6.8-3-4.4 0-6.3 1.4-6.8 3-.2.5.2 1 .8 1h12zM3 13.6c0-.3.3-.6.6-.6h12.8c.3 0 .6.3.6.6 0 1.3-1.1 2.4-2.4 2.4H5.4C4.1 16 3 14.9 3 13.6zM3.5 9C2.7 9 2 9.7 2 10.5S2.7 12 3.5 12h13c.8 0 1.5-.7 1.5-1.5S17.3 9 16.5 9h-13z"
  })));
};
export default SvgHamburger;